/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();


  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.filter-group__body .collection-nav label span').forEach(function(span) {
      span.textContent = span.textContent.replace(/[\s\u00A0]+/g, '');
 
    });
  });
document.addEventListener("DOMContentLoaded", function() {
  // Get all hidden radio fieldsets
  const hiddenFieldsets = document.querySelectorAll('.radio__fieldset.hidden');
  
  hiddenFieldsets.forEach(fieldset => {
    // Find the closest parent product__block
    const productBlock = fieldset.closest('.product__block.product__block--lines.product__form__holder.block-padding');
    
    if (productBlock) {
      productBlock.style.display = 'none';  // Hide it
    }
  });
});


// Calculate hight of titles

(() => {
  // Add any more selectors you want to equalize here.
  const SELECTORS = [
    '.product-item--centered .product-item__title',
    '.product-item--centered .product-item__price__holder'
  ];

  const mql = window.matchMedia('(max-width: 499.98px)');

  const debounce = (fn, wait = 150) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(null, args), wait);
    };
  };

  function equalizeForSelector(selector) {
    const els = Array.from(document.querySelectorAll(selector));
    if (!els.length) return;

    // Reset before measuring
    els.forEach(el => {
      el.style.height = '';
      el.style.minHeight = '';
    });

    if (!mql.matches) return; // only apply below 500px

    const max = Math.ceil(
      Math.max(...els.map(el => el.getBoundingClientRect().height || 0))
    );

    if (Number.isFinite(max) && max > 0) {
      els.forEach(el => (el.style.minHeight = max + 'px'));
    }
  }

  const runAll = debounce(() => {
    SELECTORS.forEach(equalizeForSelector);
  }, 100);

  // Initial + DOM ready / load
  document.addEventListener('DOMContentLoaded', runAll);
  window.addEventListener('load', runAll);

  // When webfonts finish loading
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(runAll).catch(() => {});
  }

  // Recalculate on resize and breakpoint changes
  window.addEventListener('resize', runAll);
  if (mql.addEventListener) mql.addEventListener('change', runAll);
  else if (mql.addListener) mql.addListener(runAll); // older Safari

  // Watch for dynamically added nodes (AJAX/infinite scroll)
  const mo = new MutationObserver(debounce((mutations) => {
    for (const m of mutations) {
      if (m.type === 'childList') {
        for (const n of m.addedNodes) {
          if (n.nodeType !== 1) continue;
          // If the added node is or contains any target selector, rerun
          if (SELECTORS.some(sel => n.matches?.(sel) || n.querySelector?.(sel))) {
            runAll();
            return;
          }
        }
      }
    }
  }, 100));

  mo.observe(document.body, { childList: true, subtree: true });
})();

